<header>
	<nav *ngIf="appSetting.isMobile" id="navbar" class="navbar navbar-expand-lg fixed-top" style="z-index:1000;">
		<div class="offset-1 col-10" style="padding: 0; height: 100%;">
			<a href="javascript:void(0);" class="navbar-brand" (click)="goHomehLink()" [ngStyle]="{'padding-top': '8px','float':'left','cursor':loggedIn?'pointer':'default'}"><img [src]="logo"></a>
			<div class="ms-auto text-end" style="padding-top:10px;">
				<div *ngIf="isAnonymous">
					<button *ngIf="allowSignup" (click)="goto('openSignup')" class="btn btn-lg btn-primary" style="background-color:white; color:#3498db!important; margin-right:5px;">Sign up</button>
					<button (click)="goto('openLogin')" class="btn btn-lg btn-primary">Login</button>
				</div>

				<div *ngIf="!isAnonymous">
					<app-notification></app-notification>

					<div ngbDropdown style="display: inline-block; vertical-align:top;">
						<span ngbDropdownToggle role="button">
							<img [src]="profileImage" class="jmRoundCenterImage">
						</span>
						<div ngbDropdownMenu class="w-100 h-100" style="top: 0; left: 0; background-color: #fff; position: fixed; padding: 5px 15px; border-radius: 0px; margin:0">
							<table class="table table-borderless" style="font-size:18px">
								<tbody>
									<tr>
										<td>
											<div style="display:inline-block">
												<div class="text-truncate" style="font-size: 30px;color: #242424; max-width:250px;">Hi, {{personInfo.FirstName}}</div>
												<app-switch-account currentZone="true"></app-switch-account>
											</div>
											<span style="color: #7F8C8D; float:right" role="button"><i ngbDropdownItem class="icnXMark display-6 text-primary"></i></span>
										</td>
									</tr>
									<tr>
										<td>
											<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/User/ProfileDashboard')">Dashboard</span>
										</td>
									</tr>
									<tr>
										<td>
											<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/Map')">Map</span>
										</td>
									</tr>
									<tr>
										<td>
											<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/MyJourney/List')">My Journeys</span>
										</td>
									</tr>
									<tr>
										<td>
											<span ngbDropdownItem role="button" (click)="goto('/User/Profile')" style="color: #242424; font-weight: 700;">
												<img [src]="profileImage" class="jmRoundCenterImage" style="margin-right: 10px !important; width:25px;">Profile
											</span>
										</td>
									</tr>
									<tr>
										<td>
											<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/User/Portfolio')"><i class="fa fa-star" aria-hidden="true" style="padding-right: 10px;"></i> Portfolio</span>
										</td>
									</tr>
									<tr>
										<td>
											<a ngbDropdownItem href="https://intercom.help/journeys-acc277045d6d" class="text-primary" target="_blank"><i class=" fa fa-life-ring" aria-hidden="true" style="padding-right: 10px;"></i> Help</a>
										</td>
									</tr>
									<ng-container *ngIf="isSystemAdmin">
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="gotoWeb()"><i class="icnUser" aria-hidden="true" style="padding-right: 10px;"></i> System Admin</span>
												<span *ngIf="loadingWeb" class="jmWidgetLoadingIcon20"></span>
											</td>
										</tr>
										<tr>
											<td>
												<span ngbDropdownItem class="text-primary" role="button" (click)="goto('/System/Dashboard')"><i class="icnGear" aria-hidden="true" style="padding-right: 10px;"></i> System Admin Settings</span>
											</td>
										</tr>
									</ng-container>
									@if(isZoneAdmin && widgetAPI.isWidgetAllowed('ZoneDashboard')) {
										<tr>
											<td>
												<a ngbDropdownItem *ngIf="userInfo.isJAZone()" class="text-primary" role="button" (click)="goto('/Zone/Admin')"><i class="icnGear" aria-hidden="true" style="padding-right: 10px;"></i> Zone Admin</a>
												<a ngbDropdownItem *ngIf="!userInfo.isJAZone()" class="text-primary" role="button" (click)="goto('/Zone/Dashboard')"><i class="icnGear" aria-hidden="true" style="padding-right: 10px;"></i> Zone Admin Settings</a>
											</td>
										</tr>
									}
									<tr>
										<td>
											<app-switch-account currentZone="false"></app-switch-account>
										</td>
									</tr>
									<tr>
										<td>
											<button class="btn btn-primary w-100" (click)="logout()" style="margin-top:15px;">Logout <i class="icnRightToBracket"></i></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nav>

	<nav *ngIf="!appSetting.isMobile" id="navbar" class="navbar navbar-expand-lg fixed-top" style="z-index:1000;">
		<!--matdiag zindex is 1000, so do not overwrite -->
		<div class="offset-1 col-10" style="padding: 0; height: 100%;">
			<a href="javascript:void(0);" class="navbar-brand" (click)="goHomehLink()" [ngStyle]="{'padding-top': '8px','float':'left','cursor':loggedIn?'pointer':'default'}"><img [src]="logo"></a>

			<div id="navDesktop" class="navbar-collapse" style="height: 100%;">
				<ul class="navbar-nav me-auto" id="navbarMyJourneysUl" stlye="height: 100%;">
					<li class="nav-item" style="margin-right:30px; display: flex; align-items: center;">
						<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('/User/ProfileDashboard')">Dashboard</a>
					</li>
					<li class="nav-item" style="margin-right: 30px; display: flex; align-items: center;">
						<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('/Map')">Map</a>
					</li>
					<li class="nav-item" style="display: flex; align-items: center;" id="nbMyJourneys">
						<a href="javascript:void(0);" class="nav-link jmNavLink" (click)="goto('/MyJourney/List')">My Journeys</a>
					</li>
				</ul>

				<ul *ngIf="!isAnonymous" class="navbar-nav">
					<li class="nav-item nav-link text-center my-auto" style="min-width: 120px; padding: 0px 10px;">
						<div class="text-truncate mx-auto" style="max-width:200px; color:#fff;">Hi, {{personInfo.FirstName}}</div>
						<app-switch-account currentZone="true"></app-switch-account>
					</li>
					<li class="nav-item">
						<app-notification></app-notification>
					</li>

					<li *ngIf="!profileReady">
						<i class="nav-link jmRoundCenterBackground" style="color: #fff; background-color: #fff;"></i>
					</li>

					<li *ngIf="profileReady" ngbDropdown class="nav-item">
						<span ngbDropdownToggle role="button"><img [src]="profileImage" class="jmRoundCenterImage"></span>
						<ul ngbDropdownMenu style="width: 240px; padding: 10px; font-size: 16px; left: -180px; overflow-y: unset;">
							<li class="jmArrowUp"></li>
							<li ngbDropdownItem class="accountOption" (click)="goto('/User/Profile')" role="button"><i class="fa fa-paper-plane" style="margin-right:10px;"></i>Profile</li>
							<li ngbDropdownItem class="accountOption" (click)="goto('/User/Portfolio')" role="button"><i class="fa fa-star" style="margin-right:10px;"></i>Portfolio</li>
							<li ngbDropdownItem class="accountOption" (click)="goto('help')" role="button"><i class="fa fa-life-ring" style="margin-right:10px;"></i>Help</li>
							<ng-container *ngIf="isSystemAdmin">
								<li ngbDropdownItem class="accountOption" (click)="gotoWeb()" role="button"><i class="icnUser" style="margin-right: 10px;"></i>System Admin <span *ngIf="loadingWeb" class="jmWidgetLoadingIcon20"></span></li>
								<li ngbDropdownItem class="accountOption" (click)="goto('/System/Dashboard')" role="button"><i class="icnGear" style="margin-right: 10px;"></i>System Admin Settings</li>
							</ng-container>
							@if(isZoneAdmin && widgetAPI.isWidgetAllowed('ZoneDashboard')) {
								<li ngbDropdownItem *ngIf="userInfo.isJAZone()" class="accountOption" (click)="goto('/Zone/Admin')" role="button"><i class="icnGear" style="margin-right: 10px;"></i>Zone Admin</li>
								<li ngbDropdownItem *ngIf="!userInfo.isJAZone()" class="accountOption" (click)="goto('/Zone/Dashboard')" role="button"><i class="icnGear" style="margin-right: 10px;"></i>Zone Admin Settings</li>
							}
							<li ngbDropdownItem style="background-color:#fff;"><app-switch-account currentZone="false"></app-switch-account></li>
							<li ngbDropdownItem style="padding:9px 9px; background-color:#fff;"><button class="btn btn-primary" (click)="logout()" style="width: 100%; margin-top: 10px;">Logout <i class="icnRightToBracket"></i></button></li>
						</ul>
					</li>
				</ul>

				<ul *ngIf="isAnonymous" class="navbar-nav me-r">
					<li class="nav-item">
						<button *ngIf="allowSignup" (click)="goto('openSignup')" class="btn btn-lg btn-primary" style="background-color:white; color:#3498db!important; margin-right:20px;">Sign up</button>
						<button (click)="goto('openLogin')" class="btn btn-lg btn-primary">Login</button>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</header>

